<template>
  <div class="mainCon">
    <div class="stuMainTitle">
      <span class="title">{{planInfo.examBeginAndEndCustomName ? planInfo.examBeginAndEndCustomName: "考试"}}</span>
    </div>
    <div class="content">
      <ots-table
        v-if="!showNull"
        :tableHeader="tableHeader"
        :tableData="tableData"
      ></ots-table>
      <div v-else class="noScore">
        <img src="@/assets/stuImg/nothing.png" alt="" />
        <span class="col_grayQ">暂无考试，请等待</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getExamList,
  goOtsStartExam,
  arrangementInfo,
} from "@/http/modules/student/exam";
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";

export default {
  name: "stuExam",
  data() {
    return {
      isCanExam: false,
      showNull: true,
      tableHeader: [
        {
          title: "考试名称",
          prop: "arrangementName",
        },
        {
          title: "开始时间",
          prop: "beginTime",
        },
        {
          title: "结束时间",
          prop: "endTime",
        },
        // {
        //   title: "考试时间",
        //   formatter: (val) => `${val.row.beginTime} --- ${val.row.endTime}`,
        // },
        {
          title: "考试状态",
          prop: "status",
        },
        {
          title: "操作",
          type: "buttons",
          width: "200",
          btnList: [
            {
              formatter:(val)=>{
                if(this.needExamOrderCode === 0){
                 return '开始考试'
                }else{
                  ''
                }
              },
              click: this.startExam,
            },
          ],
        },
      ],
      tableData: [],
      ip: "",
      needExamOrderCode:'',
      planInfo: {},
    };
  },
  created() {
    this.getExam();
    this.isSetState();
    this.getPlanInfo();
  },
  methods: {
    // // 获取系统设置
    // getConfig() {
    //   this.mixin_getSystemConfig().then((data) => {
    //     data.configList.map((item) => {
    //       if (item.setName == "needIPCheck") {
    //         if (item.setValue == 1) {
    //           this.isCanExam = true;
    //         } else {
    //           this.isCanExam = false;
    //         }
    //       }
    //     });
    //   });
    // },
    async getPlanInfo() {
      const { data, code } = await getCurrentPlanFn({planId: this.getCurrentGlobalPlanId()});
      this.planInfo = data;
    },


    isSetState() {
      this.$api.system.getConfigData().then((res) => {
        res.data.configList.map((e) => {
          if (e.setName == "needExamOrderCode") {
            this.needExamOrderCode = e.setValue;
          }
        });
        
      });
    },
    async getExam() {
      const { data } = await getExamList({
        planId: this.getCurrentGlobalPlanId(),
      });
      if (data) {
        this.tableData = data;
        if (this.tableData.length) {
          this.showNull = false;
        }
      } else {
        this.showNull = false;
      }
    },

    // 开始考试按钮
    async startExam(row) {
      if (row.canExam == 0) {
        this.$message.error("巡考系统未签到不允许答题");
        return;
      }
      if (!(row && row.arrangementId)) {
        return false;
      }
      const ipInfo = await arrangementInfo();
      if (ipInfo.code == 0) {
        return false;
      }
      let param = {
        action: "StartTestNormal",
        parames: `arrangementId=${row.arrangementId}`,
      };
      const { code, data } = await goOtsStartExam(param);
      if (code == 1) {
        window.open(data);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mainCon {
  box-sizing: border-box;
  padding: 20px;
  padding-top: 16px;
  width: 100%;
  min-width: 700pt;
  background: rgba(255, 255, 255, 0.93);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  .content {
    padding-top: 20px;
    .noScore {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 80px;
    }
  }
}
/deep/ .el-table th,
.el-table tr {
  background-color: #ebecff !important;
}
.stuMainTitle {
    font-size: 20px;
    height: 52px;
    line-height: 52px;
    font-weight: bold;
    border-bottom: 1px solid #DADDE6;
}
</style>
